import React from 'react';

const FloatingWhatsAppButton = () => {
  const whatsappNumber = '+917386770284'; // Replace with your WhatsApp number
  const message = 'Hello!'; // Optional: Pre-fill a message

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: '1000', // Ensure it's above other elements
        cursor: 'pointer',
      }}
      onClick={() => {
        window.open(whatsappLink, '_blank');
      }}
    >
      {/* You can use an image or an icon here */}
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/2044px-WhatsApp.svg.png" // Example WhatsApp icon URL
        alt="WhatsApp"
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%', // Make it circular
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)', // Add a subtle shadow
        }}
      />
    </div>
  );
};

export default FloatingWhatsAppButton;